import STTableGradient from "common/STTableGradient/STTableGradient";


const TokenUsageTable= ({ columns, rows }) => {
  return <STTableGradient columns={columns} rows={rows} width="100%" />;
};

export default TokenUsageTable;
 